import apiHandler from "../core/apiHandler";

const debitNoteLookupApi = apiHandler('debit-note-lookup');
export default debitNoteLookupApi;
